import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './standard_dialog.less'
import Dialog from 'components/common/dialog'

class StandardDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    okButtonTitle: PropTypes.string,
    closeButtonTitle: PropTypes.string,
    onOk: PropTypes.func,
    onClose: PropTypes.func,
  }

  render() {
    let propsToTransfer = { ...this.props }
    delete propsToTransfer.styles
    return (
      <Dialog {...propsToTransfer} onClose={this.props.onClose}>
        <div styleName="title">{this.props.title}</div>
        <div styleName="subtitle">{this.props.subtitle}</div>
        <button
          data-pa-click="closeDialog"
          className="vx_btn vx_btn-block"
          styleName="close-button"
          onClick={this.props.onClose}
        >
          {this.props.closeButtonTitle}
        </button>
        {this.props.okButtonTitle && (
          <button
            data-pa-click="approveDialog"
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="ok-button"
            onClick={this.props.onOk}
          >
            {this.props.okButtonTitle}
          </button>
        )}
      </Dialog>
    )
  }
}

export default cssModules(StandardDialog, styles)
